import { useParams } from "react-router-dom";
import { LoginLayout } from "../../../../layouts/Login";
import { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import { Form } from "../../../../themes/Default/components/Form";
import { Row } from "../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../themes/Default/components/Form/components/Row/components/Field";
import { useTranslation } from "react-i18next";
import { Button } from "../../../../themes/Default/components/TopNavigation/components/Button";
import { Select } from "../../../../themes/Default/components/Form/components/Select";
import { prepareSelect } from "../../../../services/core/Select";
import { Slide, toast, ToastContainer } from "react-toastify";
import { studentsManagement } from "../../../../hooks/api/StudentsManagement";
import { groupTypes } from "../../../../services/utils/GroupTypes";
import SignContractLayout from "../../../../layouts/SignContract/SignContractLayout";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

const SigneContract = () => {
    const { t } = useTranslation("common");
    const { token } = useParams();
    const { studentId } = useParams();
    const { contractId } = useParams();
    const formRef = useRef(null);
    const [formErrors, setFormErrors] = useState([]);
    const { useViewContractMutation } = studentsManagement;
    const [viewContract] = useViewContractMutation();
    const [contract, setContract] = useState([]);

    const signe = async ({ studentId, contractId, body }) => {
        const response = await fetch(`${BASE_URL}v1/${locale}/students/${studentId}/contracts/${contractId}/signed`, {
            method: "PATCH",
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json",
                ...(token && { Authorization: `Bearer ${token}` }),
            },
        });

        const result = await response.json();

        return result;
    };

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = async (values) => {
        const result = await signe({ studentId, contractId, body: values });
        if (result?.info) {
            toast.info(result.info.responseMessage);
        } else {
            toast.error(result.error.responseMessage);
            setFormErrors(result?.error?.violations);
        }
    };

    useEffect(() => {
        const fetchContract = async () => {
            try {
                const response = await fetch(`${BASE_URL}v1/${locale}/students/${studentId}/contracts/${contractId}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        ...(token && { Authorization: `Bearer ${token}` }),
                    },
                });
    
                if (!response.ok) {
                    throw new Error("Greška prilikom preuzimanja ugovora");
                }
    
                const data = await response.json();
                setContract(data);
            } catch (error) {
                console.error(error);
            }
        };
    
        fetchContract();
    }, []);

    const isCamp =
        contract?.groupTypeName === groupTypes.LETNJI_JEZICKI_KAMP ||
        contract?.groupTypeName === groupTypes.ZIMSKI_JEZICKI_KAMP ||
        contract?.groupTypeName === groupTypes.VIKEND_JEZICKI_KAMP;

    return (
        <SignContractLayout disableSplashScreen={true}>
            
            <Formik
                innerRef={formRef}
                initialValues={{
                    canBePhotographed: null,
                    canGoHomeAlone: null,
                }}
                onSubmit={onSaved}
            >
                {({ values, handleChange }) => (
                    <div className="signed-contract">
                        <Form>
                            <Row>
                                <Field>
                                    <Select
                                        name="canBePhotographed"
                                        label={
                                            <>
                                                Nalazite se na stranici za potpisivanja Ugovora. 
                                                Molimo Vas da odabirom jedne od opcija iz padajućeg menija označite da li ste saglasni sa fotografisanjem deteta za potrebe FC ATACANTE.<br/><br/>
                                                <span>Izaberite jednu od opcija:</span>
                                            </>
                                        }
                                        options={prepareSelect([
                                            { id: true, name: "Moje dete može da se fotografiše." },
                                            { id: false, name: "Dete ne može da se fotografiše." },
                                        ])}
                                        onChange={(e) => {
                                            handleChange(e);
                                        }}
                                        selectedValue={values.canBePhotographed}
                                        error={formErrors?.canBePhotographed}
                                        searchVisible={false}
                                    />
                                </Field>
                            </Row>
                            {/* {isCamp && (
                                <Row>
                                    <Field>
                                        <Select
                                            name="canGoHomeAlone"
                                            label={
                                                <>
                                                    Molimo Vas da kroz padajući meni u nastavku odaberete sa kojom ste opcijom iz Priloga 2 saglasni, a u vezi sa napuštanjem nastavnog Centra u 17h:<br/><br/>
                                                    <span>Izaberite jednu od opcija:</span>
                                                </>
                                            }
                                            options={prepareSelect([
                                                { id: true, name: "Može svakodnevno po završetku programa SAMOSTALNO da napusti Centar." },
                                                { id: false, name: "Obavezujem se da ću svoje dete preuzeti od osoblja Centra, u prostorijama Centra." },
                                            ])}
                                            onChange={handleChange}
                                            selectedValue={values.canGoHomeAlone}
                                            error={formErrors?.canGoHomeAlone}
                                            searchVisible={false}
                                        />
                                    </Field>
                                </Row>
                            )} */}
                        </Form>
                    </div>
                )}
            </Formik>
            <Button type="button" title={t("students.signeContract")} icon="fa-regular fa-pen-to-square" onClick={onSave} customClass="signed-contract__btn"></Button>
        </SignContractLayout>
    );
};

export default SigneContract;
